import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { GiftcardsBalanceFormComponent } from '../../../../../module/giftcards/giftcards-balance-form.component';
import { AccordionComponent } from '../../../../../ui/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../ui/accordion/item/accordion-item.component';
import { PAGE_COMPONENT_GIFTCARDS_CONFIG } from './giftcards.config';
import { IPageComponentGiftcardsData } from './giftcards.interface';

@Component({
    selector: 'page-component-giftcards',
    templateUrl: './giftcards.component.html',
    standalone: true,
    imports: [
        AccordionComponent,
        AccordionItemComponent,
        CommonModule,
        DfImageDirective,
        HrefComponent,
        GiftcardsBalanceFormComponent,
        GridModule,
        ICmsClientModule,
        ToggleModule,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentGiftcardsComponent>(PAGE_COMPONENT_GIFTCARDS_CONFIG)
export class PageComponentGiftcardsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentGiftcardsData;
}
